import defaultAttributes from '../defaultAttributes';

const Loader2 = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M21 12a9 9 0 11-6.219-8.56' }]],
];

export default Loader2;
